import { CSSProperties } from 'react';
import { withIcon } from './withIcon';

const EyeSvg = ({ style }: { style?: CSSProperties }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <g id="view" clipPath="url(#clip0_4299_21243)">
      <path
        id="Vector"
        d="M0.832031 7.00028C1.34632 4.08599 3.91775 1.85742 7.00346 1.85742C10.0892 1.85742 12.6606 4.08599 13.1749 7.00028C12.6606 9.91456 10.0892 12.1431 7.00346 12.1431C3.91775 12.1431 1.34632 9.91456 0.832031 7.00028ZM7.00346 9.85742C8.60346 9.85742 9.8606 8.60028 9.8606 7.00028C9.8606 5.40028 8.60346 4.14314 7.00346 4.14314C5.40346 4.14314 4.14632 5.40028 4.14632 7.00028C4.14632 8.60028 5.40346 9.85742 7.00346 9.85742ZM7.00346 8.71456C6.03203 8.71456 5.28917 7.97171 5.28917 7.00028C5.28917 6.02885 6.03203 5.28599 7.00346 5.28599C7.97489 5.28599 8.71775 6.02885 8.71775 7.00028C8.71775 7.97171 7.97489 8.71456 7.00346 8.71456Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_4299_21243">
        <rect
          width="13.7143"
          height="13.7143"
          fill="white"
          transform="translate(0.144531 0.142578)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const Eye = withIcon(EyeSvg);
